(function () {
  'use strict';

  const KEY = 'mn-intro-seen';
  const intro = document.querySelector('[data-mn-intro]');
  if (!intro) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    intro.remove();
    document.documentElement.classList.remove('mn-intro-active');
    return;
  }
  try {
    if (sessionStorage.getItem(KEY)) {
      intro.remove();
      document.documentElement.classList.remove('mn-intro-active');
      return;
    }
  } catch (e) { /* sessionStorage may be unavailable */ }

  document.documentElement.classList.add('mn-intro-locked');
  if (window.__lenisGlobal && typeof window.__lenisGlobal.stop === 'function') {
    window.__lenisGlobal.stop();
  }
  window.scrollTo(0, 0);

  function release() {
    document.documentElement.classList.remove('mn-intro-locked');
    if (window.__lenisGlobal && typeof window.__lenisGlobal.start === 'function') {
      window.__lenisGlobal.start();
    }
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }

  // Timeline (~4.5s total)
  // t=0     — title fade-in 0.7s
  // t=600   — gold reveal 0.85s + image reveal lagged 0.55s
  //           gold ends at t=1450, image ends at t=2000
  // t=3050  — exit (image 0.85s, gold +0.15s, overlay +0.3s) ends t=4200
  // t=4200  — kill backdrop-filter / bg (release page)
  // t=4500  — remove

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      intro.classList.add('is-stage-1');
    });
  });

  setTimeout(() => intro.classList.add('is-stage-2'), 600);

  setTimeout(() => {
    intro.classList.add('is-exit');
    release();
    // Release the hero animations to start playing in sync with the intro exit
    document.documentElement.classList.remove('mn-intro-active');
  }, 3050);

  // As soon as the visual exit is done, neutralize the overlay (no more backdrop-filter)
  setTimeout(() => intro.classList.add('is-done'), 4200);

  setTimeout(() => intro.remove(), 4500);
})();
